/**
 *
 * Theme
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Theme as StyledTheme } from '@cashfree-intl/coherent';

import {
  isICICIDashboard,
  isLKDashboard,
  isIDFCDashboard,
  isAxisDashboard,
} from '../../utils/common';
import designTokens from '../../utils/designTokens';
import {
  ICICIMERCHANT,
  LENDINGKARTMERCHANT,
  IDFCMERCHANT,
  AXISEASYPAYPLUS,
} from '../../utils/constants';

function Theme(props) {
  let theme = null;
  document.querySelector('html').className = 'default';

  if (isICICIDashboard()) {
    document.querySelector('html').className = 'icici-eazypro';
    theme = designTokens[ICICIMERCHANT];
  } else if (isLKDashboard()) {
    document.querySelector('html').className = 'lending-kart';
    theme = designTokens[LENDINGKARTMERCHANT];
  } else if (isIDFCDashboard()) {
    document.querySelector('html').className = 'idfc';
    theme = designTokens[IDFCMERCHANT];
  } else if (isAxisDashboard()) {
    document.querySelector('html').className = 'axis-easypayplus';
    theme = designTokens[AXISEASYPAYPLUS];
  }

  return <StyledTheme theme={theme}>{props.children}</StyledTheme>;
}

Theme.propTypes = {
  children: PropTypes.element.isRequired,
};

export default memo(Theme);
